/**
 * 考试预览demo
 * @description 考试预览demo
 * @author mll
 * @date 2020-2-14
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '../../../tool'
import { ExamPreview } from '../../../components'
let { WizUpload, WizIcon, WizButton } = component_tool;
let { WizContainer } = framework_tool;

const examPaper = {
    id: 0,//主键
    title: '考试预览Demo考试的考试名称',//考试名称
    totalScore: 100,//考试总分
    passScore: 60,//通过分数
    limitMinutes: 60,//考试时间限制
    parts: [
        {
            id: 0,//主键
            title: '单选题',//题目
            size: 4,//题目数量
            score: 5,//单题分数
            questions: [
                {
                    id: 0,
                    type: 0,//题目类型 0单选题 1多选题 2判断题 3填空题 4主观题
                    title: '对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？',//题干
                    img: '',//题目图片
                    correct: 0,//正确答案
                    options: [
                        {
                            id: 0,
                            name: '消费100元享受130元产品',
                            img: ''
                        },
                        {
                            id: 1,
                            name: '8折优惠',
                            img: ''
                        },
                        {
                            id: 2,
                            name: '买三送一',
                            img: ''
                        },
                        {
                            id: 3,
                            name: '先立减20元，再打9折',
                            img: ''
                        }
                    ]
                },
                {
                    id: 1,
                    type: 0,//题目类型 0单选题 1多选题 2判断题 3填空题 4主观题
                    title: '对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？',//题干
                    img: '',//题目图片
                    correct: 1,//正确答案
                    options: [
                        {
                            id: 0,
                            name: '消费100元享受130元产品',
                            img: ''
                        },
                        {
                            id: 1,
                            name: '8折优惠',
                            img: ''
                        },
                        {
                            id: 2,
                            name: '买三送一',
                            img: ''
                        },
                        {
                            id: 3,
                            name: '先立减20元，再打9折',
                            img: ''
                        }
                    ]
                },
                {
                    id: 2,
                    type: 0,//题目类型 0单选题 1多选题 2判断题 3填空题 4主观题
                    title: '对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？',//题干
                    img: '',//题目图片
                    correct: 2,//正确答案
                    options: [
                        {
                            id: 0,
                            name: '消费100元享受130元产品',
                            img: ''
                        },
                        {
                            id: 1,
                            name: '8折优惠',
                            img: ''
                        },
                        {
                            id: 2,
                            name: '买三送一',
                            img: ''
                        },
                        {
                            id: 3,
                            name: '先立减20元，再打9折',
                            img: ''
                        }
                    ]
                },
                {
                    id: 3,
                    type: 0,//题目类型 0单选题 1多选题 2判断题 3填空题 4主观题
                    title: '对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？对售价130元的配件来说，以下哪种促销优惠力度最大？',//题干
                    img: '',//题目图片
                    correct: 3,//正确答案
                    options: [
                        {
                            id: 0,
                            name: '消费100元享受130元产品',
                            img: ''
                        },
                        {
                            id: 1,
                            name: '8折优惠',
                            img: ''
                        },
                        {
                            id: 2,
                            name: '买三送一',
                            img: ''
                        },
                        {
                            id: 3,
                            name: '先立减20元，再打9折',
                            img: ''
                        }
                    ]
                }
            ]
        },
        {
            id: 1,//主键
            title: '多选题',//题目
            size: 1,//题目数量
            score: 20,//单题分数
            questions: [
                {
                    id: 0,
                    type: 1,//题目类型 0单选题 1多选题 2判断题 3填空题 4主观题
                    title: '对售价130元的配件来说，以下哪种促销优惠力度最大？',//题干
                    img: 'https://www.w3school.com.cn/i/eg_tulip.jpg',//题目图片
                    correct: [0, 2, 3],//正确答案
                    options: [
                        {
                            id: 0,
                            name: '消费100元享受130元产品',
                            img: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3301642898,92830133&fm=26&gp=0.jpg'
                        },
                        {
                            id: 1,
                            name: '8折优惠',
                            img: 'https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2033652965,2723161418&fm=26&gp=0.jpg'
                        },
                        {
                            id: 2,
                            name: '买三送一',
                            img: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1581699022047&di=30a28444f7785a81f0359a161122a849&imgtype=0&src=http%3A%2F%2Fi6.download.fd.pchome.net%2Ft_600x1024%2Fg1%2FM00%2F0E%2F06%2FoYYBAFTb-eqILqeIAATCIZFvlRAAACSZgOGJqgABMI5402.jpg'
                        },
                        {
                            id: 3,
                            name: '先立减20元，再打9折',
                            img: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=3892543522,2934172096&fm=26&gp=0.jpg'
                        }
                    ]
                }
            ]
        },
        {
            id: 2,//主键
            title: '判断题',//题目
            size: 1,//题目数量
            score: 20,//单题分数
            questions: [
                {
                    id: 0,
                    type: 2,//题目类型 0单选题 1多选题 2判断题 3填空题 4主观题
                    title: '对售价130元的配件来说，以下哪种促销优惠力度最大？',//题干
                    img: '',//题目图片
                    correct: 0,//正确答案 0正确，1错误
                }
            ]
        },
        {
            id: 3,//主键
            title: '填空题',//题目
            size: 1,//题目数量
            score: 20,//单题分数
            questions: [
                {
                    id: 0,
                    type: 3,//题目类型 0单选题 1多选题 2判断题 3填空题 4主观题
                    title: '通用的三大品牌有哪些?',//题干
                    img: '',//题目图片
                    correct: [['别克', '通用别克', '别克品牌'], ['雪佛兰', '通用雪佛兰']],
                    analysis: '别克、雪佛兰、凯迪拉克'
                }
            ]
        },
        {
            id: 4,//主键
            title: '主观题',//题目
            size: 1,//题目数量
            score: 20,//单题分数
            questions: [
                {
                    id: 0,
                    type: 4,//题目类型 0单选题 1多选题 2判断题 3填空题 4主观题
                    title: '全新一代凯越9月份开始做了哪些政策方面的调整？调整的目的是什么？',//题干
                    img: '',//题目图片
                    correct: '新凯越传承了别克新一代家族化设计的元素和理念，搭配全新一代6速手自一体变速箱和5速手动变速箱，在油耗、动力性能和静音各方面实现全面提升。'
                }
            ]
        }
    ],//章节
}

class ExamPreviewDemo extends WizContainer {

    componentName = 'ExamPreviewDemo';



    _render() {
        return (
           <ExamPreview data={examPaper} />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {

    };
};

export default connect(mapStateToProps)(ExamPreviewDemo);
